import Sql from './sql.vue'
import Record from './record.vue'

export default {
  Sql,
  Record
}



// WEBPACK FOOTER //
// ./src/views/sql/index.js